import ApiInstance from './intercepter';
import API from '../config/api';


export const allProgramList = params => ApiInstance.get(API.ALL_PROGRAM_LIST + params);

export const getDashboardService = params => ApiInstance.get(API.USER_DASHBOARD + params);